import { useCallback } from 'react';
import { SearchSelectField } from '@/components/ui';
import { fetchProductOptions, resolveProductOption } from './productSelectLoaders';

export interface ProductSelectorProps {
  value: string | null;
  disabled?: boolean;
  placeholder?: string;
  errorMessage?: string | null | undefined;
  onChange: (productId: string | null) => void;
  excludeIds?: readonly string[];
}

export const ProductSelector = ({
  value,
  disabled,
  placeholder = '상품명으로 검색',
  errorMessage,
  onChange,
  excludeIds,
}: ProductSelectorProps) => {
  const loadOptions = useCallback(
    (q: string, page: number) => fetchProductOptions(q, page),
    [],
  );
  const resolveOption = useCallback((v: string) => resolveProductOption(v), []);

  return (
    <SearchSelectField
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      resolveOption={resolveOption}
      placeholder={placeholder}
      emptyMessage="검색 결과가 없습니다"
      loadingMessage="검색 중..."
      testId="product-selector"
      {...(disabled !== undefined ? { disabled } : {})}
      {...(errorMessage !== undefined && errorMessage !== null ? { errorMessage } : {})}
      {...(excludeIds !== undefined ? { excludeValues: excludeIds } : {})}
    />
  );
};
